// Triggered in Block

import { BLOCK_TRANSITION } from '../state-constants/stateConstants';

export const blockTransition = (bool) => ({
  type: BLOCK_TRANSITION,
  payload: bool,
});



// WEBPACK FOOTER //
// ./src/state-actions/blockTransition.js